import { FeatureFlags } from '#lib/constants/feature-flags.js';
import { primaryGalleryPageLoad } from '#lib/websites/primary/pages/PrimaryGalleryPage/utils/primaryGalleryPageLoad/primaryGalleryPageLoad.js';
import { primaryGalleryPageLoadGql } from '#lib/websites/primary/pages/PrimaryGalleryPage/utils/primaryGalleryPageLoadGql/primaryGalleryPageLoadGql.js';

export const load = FeatureFlags.RestPages[
	'/primary/collection/[collectionSlug]'
]
	? primaryGalleryPageLoad
	: primaryGalleryPageLoadGql;
